<script setup lang="ts">
/**
 * Base Close Button
 * --------------------------------
 * (x) button
 */
</script>

<template>
    <button
        class="flex items-center justify-center rounded-full bg-brand-b p-0.5 text-white hover:bg-shade-2 hover:text-brand-b"
        :aria-label="$t('core.buttons.close')"
    >
        <Icon name="tot:x" class="size-4" />
    </button>
</template>
